import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'

import { from, switchMap } from 'rxjs'

import { HttpRoutes } from '@enums/http-routes'
import { RecaptchaService } from '@services/recaptcha'
import { RecaptchaState } from '@states/recaptcha-state'

const PROTECTED_PATHS = [HttpRoutes.FreedompayInit, HttpRoutes.FreedompaySubmit]

export const recaptchaInterceptor: HttpInterceptorFn = (req, next) => {
	const recaptchaService = inject(RecaptchaService)
	const recaptchaState = inject(RecaptchaState)
	const isProtected = PROTECTED_PATHS.some((path) => req.url.includes(path))

	if (!isProtected) return next(req)

	return from(recaptchaService.refresh()).pipe(
		switchMap(() => {
			const token = recaptchaState.token()
			const headers = req.headers.set('ReCaptcha-Token', token)
			return next(req.clone({ headers }))
		})
	)
}
